import { z } from 'zod';
import { FromSchema } from '@40seas/entities/common';

export const ComplyAdvantageMatchSchema = z
    .object({
        name: z.number(),
        address: z.number(),
    })
    .strict();

export class ComplyAdvantageMatch extends FromSchema(ComplyAdvantageMatchSchema) {
    name: number;
    address: number;
}
